import React from "react"
import "./contact-us.scss"
import imgWoman from "../../../assets/images/contact/performance/img-contacto.webp"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import { useStaticQuery, graphql } from "gatsby"

const ContactUs = props => {
  // const filteredResult = resultQuery.allContentfulNolHomeTercerNivel.nodes.filter(e => e.node_locale === process.env.LOCALE)

  const resultQuery = useStaticQuery(
    graphql`
      query FOOTER_CONTACT_QUERY {
        allContentfulNolContactanos {
          nodes {
            contacto {
              json
            }
            node_locale
          }
        }
      }
    `
  )

  const params = resultQuery.allContentfulNolContactanos.nodes.filter(
    e => e.node_locale === process.env.LOCALE
  )[0].contacto

  return (
    <section className="f-contactus-section">
      <div className="f-info-container">
        <img className="f-woman-img" src={imgWoman} alt="Imagen mujer" />
        <div className="f-box-text-container">
          <div className="f-list-info-container">
            {documentToReactComponents(params.json)}
          </div>
        </div>
      </div>
    </section>
  )
}

export default ContactUs
